if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.productInfo = this.closest('product-info');
        this.variantIdInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.barQuantity = document.querySelector('[data-id="barQuantity"]');
        this.hasImageUpload = this.dataset.customizationImageCount === 'true';
        this.isImageUploadMandetory = this.dataset.imageUploadMandetory === 'true';
        this.imageUploadErrorMessage = this.dataset.imageUploadErrorMessage;

        this.hasProductMessage = this.dataset.customizationCharacterLimit === 'true';
        this.isProductMessageMandetory = this.dataset.productMessageMandetory === 'true';
        this.productMessageErrorMessage = this.dataset.productMessageErrorMessage;

        this.isQuickViewModal = this.closest('quick-add-modal') || null;

        // Set Default City Onload
        this.dataset.city = localStorage.getItem('city_value') ? localStorage.getItem('city_value') : 'Riyadh';
        this.dataset.arabicCity = localStorage.getItem('arabic_city_value') ? localStorage.getItem('arabic_city_value') : 'الرياض';
        // Also set the data attributes for compatibility
        this.setAttribute('data-city', this.dataset.city);
        this.setAttribute('data-arabic-city', this.dataset.arabicCity);

        // Set City on City Change
        document.addEventListener('city-changed', (event) => {
          
          // Handle both possible event formats
          let newCity = event.detail.textValue || event.detail.city || event.detail.value;
          let newArabicCity = event.detail.arabicTextValue || event.detail.arabicCity;
          
          if (newCity) {
            this.dataset.city = newCity;
            this.dataset.arabicCity = newArabicCity || newCity;
            // Also set the data attributes for compatibility
            this.setAttribute('data-city', newCity);
            this.setAttribute('data-arabic-city', newArabicCity || newCity);
            this.checkCityAvailability();
          } else {
            console.warn('ProductForm: city-changed event missing city data:', event.detail);
          }
        });

        // Listen for localStorage changes (in case city is changed from other parts of the app)
        window.addEventListener('storage', (event) => {
          if (event.key === 'city_value' || event.key === 'city') {
            const newCity = event.newValue || 'Riyadh';
            const isSameCity = window.CityMatcher ? window.CityMatcher.match(newCity, this.dataset.city) : newCity === this.dataset.city;
            if (!isSameCity) {
              this.dataset.city = newCity;
              // Get Arabic city name using CityMatcher
              const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(newCity, true) : newCity;
              this.dataset.arabicCity = arabicCity;
              // Also set the data attributes for compatibility
              this.setAttribute('data-city', newCity);
              this.setAttribute('data-arabic-city', arabicCity);
              this.checkCityAvailability();
            }
          }
        });

        // Listen for custom location change events (from location dropdown)
        document.addEventListener('location-changed', (event) => {
          if (event.detail && event.detail.city) {
            this.dataset.city = event.detail.city;
            // Get Arabic city name using CityMatcher
            const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(event.detail.city, true) : event.detail.city;
            this.dataset.arabicCity = arabicCity;
            // Also set the data attributes for compatibility
            this.setAttribute('data-city', event.detail.city);
            this.setAttribute('data-arabic-city', arabicCity);
            this.checkCityAvailability();
          }
        });

        // Listen for any city-related events
        document.addEventListener('city-updated', (event) => {
          if (event.detail && event.detail.city) {
            this.dataset.city = event.detail.city;
            // Get Arabic city name using CityMatcher
            const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(event.detail.city, true) : event.detail.city;
            this.dataset.arabicCity = arabicCity;
            // Also set the data attributes for compatibility
            this.setAttribute('data-city', event.detail.city);
            this.setAttribute('data-arabic-city', arabicCity);
            this.checkCityAvailability();
          }
        });

        // Listen for manual city update events
        document.addEventListener('force-city-update', (event) => {
          if (event.detail && event.detail.city) {
            this.dataset.city = event.detail.city;
            // Get Arabic city name using CityMatcher
            const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(event.detail.city, true) : event.detail.city;
            this.dataset.arabicCity = arabicCity;
            // Also set the data attributes for compatibility
            this.setAttribute('data-city', event.detail.city);
            this.setAttribute('data-arabic-city', arabicCity);
            this.checkCityAvailability();
          }
        });

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.barInput = this.barQuantity ? this.barQuantity.querySelector("input") : null;
        
        // Check city availability on initialization
        this.checkCityAvailability();
        
        // For personalized gifts, ensure button is enabled by default
        this.ensureButtonEnabledForPersonalizedGifts();
        
        // Listen for image upload events to update button opacity
        this.setupImageUploadListener();
        
        // Set up periodic city check to ensure synchronization
        setInterval(() => {
          const currentCity = localStorage.getItem('city_value');
          const currentCityAlt = localStorage.getItem('city');
          
          // Check both possible localStorage keys
          const newCity = currentCity || currentCityAlt;
          
          if (newCity && newCity !== this.dataset.city) {
            this.dataset.city = newCity;
            // Get Arabic city name using CityMatcher
            const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(newCity, true) : newCity;
            this.dataset.arabicCity = arabicCity;
            // Also set the data attributes for compatibility
            this.setAttribute('data-city', newCity);
            this.setAttribute('data-arabic-city', arabicCity);
            this.checkCityAvailability();
          }
          
          // Also check if the city display in the header has changed
          const headerCityDisplay = document.querySelector('.city-display-text');
          if (headerCityDisplay) {
            const displayText = headerCityDisplay.textContent;
            // Extract city name from display text (remove "Deliver to:" prefix)
            const extractedCity = displayText.replace(/^(Deliver to:|يسلم إلى:)\s*/i, '').trim();
            if (extractedCity && extractedCity !== this.dataset.city && extractedCity !== 'Deliver to:' && extractedCity !== 'يسلم إلى:') {
              this.dataset.city = extractedCity;
              // Get Arabic city name using CityMatcher
              const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(extractedCity, true) : extractedCity;
              this.dataset.arabicCity = arabicCity;
              // Also set the data attributes for compatibility
              this.setAttribute('data-city', extractedCity);
              this.setAttribute('data-arabic-city', arabicCity);
              this.checkCityAvailability();
            }
          }
          
          // Also check if the city display in the city-selector-dropdown has changed
          const citySelectorButton = document.querySelector('[data-id="dropdown-button"] .city_label');
          if (citySelectorButton) {
            const citySelectorText = citySelectorButton.textContent;
            if (citySelectorText && citySelectorText !== this.dataset.city && 
                citySelectorText !== 'Select City' && citySelectorText !== 'اختر المدينة') {
              this.dataset.city = citySelectorText;
              // Get Arabic city name using CityMatcher
              const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(citySelectorText, true) : citySelectorText;
              this.dataset.arabicCity = arabicCity;
              // Also set the data attributes for compatibility
              this.setAttribute('data-city', citySelectorText);
              this.setAttribute('data-arabic-city', arabicCity);
              this.checkCityAvailability();
            }
          }
        }, 1000); // Check every 1 second for faster response

        // Also watch for any changes in the header or location elements
        this.watchForLocationChanges();
      }

      /**
       * Check if the selected city is available for this product
       * and update button state accordingly
       */
      checkCityAvailability() {
        const selectedCity = this.dataset.city;
        const listOfCities = this.dataset.listOfCities;
        
        
        // If no cities are specified in the metafield, allow all cities
        if (!listOfCities || listOfCities.trim() === '') {
          return;
        }
        
        if (!selectedCity) {
          return;
        }
        
        // Parse the list of cities from the metafield and normalize them
        const availableCities = listOfCities.split(',').map(city => this.normalizeCityName(city));
        const normalizedSelectedCity = this.normalizeCityName(selectedCity);
        
        
        // Check for exact match first
        let isCityAvailable = availableCities.includes(normalizedSelectedCity);
        
        // If no exact match, try partial matching for better user experience
        if (!isCityAvailable) {
          isCityAvailable = availableCities.some(city => {
            // Check if either city contains the other
            const containsMatch = city.includes(normalizedSelectedCity) || 
                                 normalizedSelectedCity.includes(city);
            
            // Check for key city name matches (e.g., "khobar" in "al khobar")
            const keyWords = normalizedSelectedCity.split(' ').filter(word => word.length > 2);
            const cityKeyWords = city.split(' ').filter(word => word.length > 2);
            
            const keywordMatch = keyWords.some(keyword => 
              cityKeyWords.some(cityKeyword => 
                cityKeyword.includes(keyword) || keyword.includes(cityKeyword)
              )
            );
            
            return containsMatch || keywordMatch;
          });
        }
        
        
        
        // Get all submit buttons (main button and addon button)
        const submitButtons = this.querySelectorAll('[type="submit"], #AddonProductModalOpener');
        
        submitButtons.forEach(button => {
          const buttonText = button.querySelector('span');
          if (!buttonText) return;
          
          // Check if button should be enabled based on city availability and other conditions
          const shouldEnableButton = this.shouldEnableButton(button, isCityAvailable);
          
          if (shouldEnableButton) {
            // Enable button and show "Add to Cart"
            button.disabled = false;
            button.removeAttribute('aria-disabled');
            buttonText.textContent = window.variantStrings?.addToCart || 'Add to Cart';
            button.classList.remove('button--disabled');
            // Add personalized gift class if this is a personalized gift product
            if (this.hasImageUpload && this.isImageUploadMandetory) {
              button.classList.add('button--personalized-gift');
            }
          } else {
            // Disable button and show appropriate message
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
            
            if (!isCityAvailable) {
              // City not available - use translation with proper city name
              const isArabic = document.documentElement.lang === 'ar';
              const displayCityName = this.getCityDisplayName(selectedCity, isArabic);
              const translationText = isArabic ? 
                `غير متوفر في ${displayCityName}` : 
                `Not Available in ${displayCityName}`;
              
              buttonText.textContent = translationText;
              button.classList.add('button--disabled');
            } else {
              // Other reason (sold out, etc.) - keep existing text
            }
          }
        });
        
        // Dispatch a custom event to notify other components about city availability change
        this.dispatchEvent(new CustomEvent('city-availability-changed', {
          detail: {
            isAvailable: isCityAvailable,
            selectedCity: selectedCity,
            availableCities: availableCities
          }
        }));
        
        // Update button opacity based on image status (only if city is available)
        if (isCityAvailable) {
          this.updateButtonOpacityForImageUpload();
        }
      }

      /**
       * Get the display name for a city based on language
       */
      getCityDisplayName(cityName, isArabic) {
        // Use global CityMatcher if available, otherwise fallback to local logic
        if (window.CityMatcher && window.CityMatcher.getCityDisplayName) {
          return window.CityMatcher.getCityDisplayName(cityName, isArabic);
        }
        
        // Fallback to original city name
        return cityName;
      }

      /**
       * Normalize city name for better matching
       */
      normalizeCityName(cityName) {
        if (!cityName) return '';
        
        let normalized = cityName.toLowerCase().trim();
        
        // Remove common prefixes/suffixes
        normalized = normalized.replace(/^(city of|deliver to|يسلم إلى:?)\s*/i, '');
        normalized = normalized.replace(/\s+(city|مدينة)$/i, '');
        
        // Normalize hyphens and spaces for consistent matching - remove all hyphens and normalize spaces
        normalized = normalized.replace(/[-\s_]+/g, ' ').trim();
        
        // Handle common abbreviations
        normalized = normalized.replace(/\balk\b/g, 'al ');
        normalized = normalized.replace(/\bkh\b/g, 'khobar');
        
        // Handle common city variations
        const cityMappings = {
          'riyadh': 'riyadh',
          'الرياض': 'riyadh',
          'al khobar': 'al khobar',
          'al-khobar': 'al khobar',
          'al_khobar': 'al khobar',
          'alkhobar': 'al khobar',
          'khobar': 'al khobar',
          'الخبر': 'al khobar',
          'al khobar city': 'al khobar',
          'city of al khobar': 'al khobar',
          'city of khobar': 'al khobar',
          'dammam': 'dammam',
          'الدمام': 'dammam',
          'dhahran': 'dhahran',
          'الظهران': 'dhahran',
          'jubail': 'jubail',
          'الجبيل': 'jubail',
          'jeddah': 'jeddah',
          'جدة': 'jeddah',
          'qatif' : 'qatif',
          'القطيف' : 'qatif',
          'madinah':'المدينة',
          'المدينة':'madinah',
          'مكه':'meccah'
        };
        
        // Check if we have a direct mapping
        if (cityMappings[normalized]) {
          return cityMappings[normalized];
        }
        
        return normalized;
      }

      /**
       * Manually refresh city availability check
       * Useful for testing or when city is changed programmatically
       */
      refreshCityAvailability() {
        // Update city from localStorage
        this.dataset.city = localStorage.getItem('city_value') || 'Riyadh';
        this.dataset.arabicCity = localStorage.getItem('arabic_city_value') || 'الرياض';
        // Also set the data attributes for compatibility
        this.setAttribute('data-city', this.dataset.city);
        this.setAttribute('data-arabic-city', this.dataset.arabicCity);
        
        
        // Re-check availability
        this.checkCityAvailability();
  }

  /**
   * Convert city name to English format
   * @param {string} cityName - The city name (could be Arabic or English)
   * @returns {string} - English city name
   */
  convertToEnglishCity(cityName) {
    if (!cityName || cityName === 'null') return 'Riyadh';
    
    // If already English, return as is
    const englishCities = ['Riyadh', 'Jeddah', 'Al Khobar', 'Dammam', 'Dhahran', 'Jubail','Qatif','Madinah','Meccah'];
    if (englishCities.includes(cityName)) {
      return cityName;
    }
    
    // Convert Arabic to English
    const arabicToEnglish = {
      'الرياض': 'Riyadh',
      'جدة': 'Jeddah',
      'الخبر': 'Al Khobar',
      'الدمام': 'Dammam',
      'الظهران': 'Dhahran',
      'الجبيل': 'Jubail',
      'القطيف' : 'Qatif',
      'المدينة':'Madinah',
      'مكه':'Meccah'
    };
    
    return arabicToEnglish[cityName] || cityName;
  }

  /**
   * Get current city availability status
   */
      getCityAvailabilityStatus() {
        const selectedCity = this.dataset.city;
        const listOfCities = this.dataset.listOfCities;
        
        if (!listOfCities || listOfCities.trim() === '' || !selectedCity) {
          return { isAvailable: true, selectedCity, availableCities: [] };
        }
        
        const availableCities = listOfCities.split(',').map(city => this.normalizeCityName(city));
        const normalizedSelectedCity = this.normalizeCityName(selectedCity);
        
        let isCityAvailable = availableCities.includes(normalizedSelectedCity);
        
        if (!isCityAvailable) {
          isCityAvailable = availableCities.some(city => 
            city.includes(normalizedSelectedCity) || 
            normalizedSelectedCity.includes(city)
          );
        }
        
        return {
          isAvailable: isCityAvailable,
          selectedCity,
          availableCities
        };
      }

      /**
       * Watch for location changes in the DOM
       */
      watchForLocationChanges() {
        // Watch for changes in the header area where location might be displayed
        const header = document.querySelector('header') || document.querySelector('.header');
        if (header) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList' || mutation.type === 'characterData') {
                // Check if any text content changed that might indicate a city change
                const currentCity = localStorage.getItem('city_value');
                if (currentCity && currentCity !== this.dataset.city) {
                  this.dataset.city = currentCity;
                  // Get Arabic city name using CityMatcher
                  const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(currentCity, true) : currentCity;
                  this.dataset.arabicCity = arabicCity;
                  // Also set the data attributes for compatibility
                  this.setAttribute('data-city', currentCity);
                  this.setAttribute('data-arabic-city', arabicCity);
                  this.checkCityAvailability();
                }
              }
            });
          });
          
          observer.observe(header, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }

        // Also watch for any elements with city-related classes or IDs
        const cityElements = document.querySelectorAll('[class*="city"], [id*="city"], [class*="location"], [id*="location"]');
        cityElements.forEach(element => {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList' || mutation.type === 'characterData') {
                const currentCity = localStorage.getItem('city_value');
                if (currentCity && currentCity !== this.dataset.city) {
                  this.dataset.city = currentCity;
                  // Get Arabic city name using CityMatcher
                  const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(currentCity, true) : currentCity;
                  this.dataset.arabicCity = arabicCity;
                  // Also set the data attributes for compatibility
                  this.setAttribute('data-city', currentCity);
                  this.setAttribute('data-arabic-city', arabicCity);
                  this.checkCityAvailability();
                }
              }
            });
          });
          
          observer.observe(element, {
            childList: true,
            subtree: true,
            characterData: true
          });
        });

        // Add click listener to detect any clicks that might change the city
        document.addEventListener('click', (event) => {
          // Check if the click was on a city/location related element
          const target = event.target;
          if (target.closest('[class*="city"], [id*="city"], [class*="location"], [id*="location"], [class*="dropdown"], [id*="dropdown"]')) {
            // Wait a bit for the change to happen, then check
            setTimeout(() => {
              const currentCity = localStorage.getItem('city_value');
              if (currentCity && currentCity !== this.dataset.city) {
                this.dataset.city = currentCity;
                // Get Arabic city name using CityMatcher
                const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(currentCity, true) : currentCity;
                this.dataset.arabicCity = arabicCity;
                // Also set the data attributes for compatibility
                this.setAttribute('data-city', currentCity);
                this.setAttribute('data-arabic-city', arabicCity);
                this.checkCityAvailability();
              }
            }, 100);
          }
        });
      }

      /**
       * Force update city from localStorage and refresh availability
       */
      forceCityUpdate() {
        const currentCity = localStorage.getItem('city_value') || localStorage.getItem('city');
        if (currentCity && currentCity !== this.dataset.city) {
          this.dataset.city = currentCity;
          // Get Arabic city name using CityMatcher
          const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(currentCity, true) : currentCity;
          this.dataset.arabicCity = arabicCity;
          // Also set the data attributes for compatibility
          this.setAttribute('data-city', currentCity);
          this.setAttribute('data-arabic-city', arabicCity);
          this.checkCityAvailability();
        }
      }

      /**
       * Update city directly and refresh availability
       */
      updateCity(city) {
        if (city && city !== this.dataset.city) {
          this.dataset.city = city;
          // Get Arabic city name using CityMatcher
          const arabicCity = window.CityMatcher ? window.CityMatcher.getCityDisplayName(city, true) : city;
          this.dataset.arabicCity = arabicCity;
          // Also set the data attributes for compatibility
          this.setAttribute('data-city', city);
          this.setAttribute('data-arabic-city', arabicCity);
          this.checkCityAvailability();
        }
      }

      /**
       * Determine if button should be enabled based on city availability and other conditions
       */
      shouldEnableButton(button, isCityAvailable) {
        // If city is not available, button should be disabled
        if (!isCityAvailable) {
          return false;
        }
        
        // Check if button was disabled for other reasons (sold out, unavailable, etc.)
        const isSoldOut = button.hasAttribute('disabled') && 
                          button.getAttribute('aria-disabled') === 'true' &&
                          button.classList.contains('disabled');
        
        const hasSoldOutMessage = button.querySelector('.sold-out-message') && 
                                 !button.querySelector('.sold-out-message').classList.contains('hidden');
        
        // If button was disabled for sold out or other product issues, don't enable it
        if (isSoldOut || hasSoldOutMessage) {
          return false;
        }
        
        // City is available and no other restrictions - enable button
        return true;
      }

      /**
       * Ensure button is enabled by default for personalized gifts
       * This overrides any image upload requirements for initial button display
       * But respects city availability restrictions
       */
      ensureButtonEnabledForPersonalizedGifts() {
        // Only apply this logic for products with image upload requirements
        if (!this.hasImageUpload || !this.isImageUploadMandetory) {
          return;
        }

        // Check city availability first
        const cityStatus = this.getCityAvailabilityStatus();
        const isCityAvailable = cityStatus.isAvailable;

        // Get all submit buttons
        const submitButtons = this.querySelectorAll('[type="submit"], #AddonProductModalOpener');
        
        submitButtons.forEach(button => {
          const buttonText = button.querySelector('span');
          if (!buttonText) return;
          
          // Only enable if button is not disabled for other reasons (sold out, etc.)
          const isSoldOut = button.hasAttribute('disabled') && 
                            button.getAttribute('aria-disabled') === 'true' &&
                            button.classList.contains('disabled');
          
          const hasSoldOutMessage = button.querySelector('.sold-out-message') && 
                                   !button.querySelector('.sold-out-message').classList.contains('hidden');
          
          // Check if button is disabled due to city unavailability
          const isDisabledForCity = button.classList.contains('button--disabled') && 
                                   buttonText.textContent.includes('Not Available in');
          
          if (!isSoldOut && !hasSoldOutMessage && !isDisabledForCity) {
            // Enable button and show "Add to Cart"
            button.disabled = false;
            button.removeAttribute('aria-disabled');
            buttonText.textContent = window.variantStrings?.addToCart || 'Add to Cart';
            button.classList.remove('button--disabled');
            // Add personalized gift class for styling
            button.classList.add('button--personalized-gift');
          }
        });
        
        // Update button opacity based on current image status (only if city is available)
        if (isCityAvailable) {
          this.updateButtonOpacityForImageUpload();
        }
      }

      /**
       * Set up listener for image upload events to update button opacity
       */
      setupImageUploadListener() {
        // Only set up listener for personalized gifts with mandatory image upload
        if (!this.hasImageUpload || !this.isImageUploadMandetory) {
          return;
        }

        // Listen for custom image upload events
        document.addEventListener('image-uploaded', (event) => {
          this.updateButtonOpacityForImageUpload();
        });

        // Listen for image removal events
        document.addEventListener('image-removed', (event) => {
          this.updateButtonOpacityForImageUpload();
        });

        // Also listen for changes in the image URLs data attribute
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-image-urls') {
              this.updateButtonOpacityForImageUpload();
            }
          });
        });

        // Observe changes to the product info element
        if (this.productInfo) {
          observer.observe(this.productInfo, {
            attributes: true,
            attributeFilter: ['data-image-urls']
          });
        }

        // Also check periodically for changes (fallback)
        setInterval(() => {
          this.updateButtonOpacityForImageUpload();
        }, 1000);
      }

      /**
       * Update button opacity based on image upload status
       */
      updateButtonOpacityForImageUpload() {
        // Only apply to personalized gifts with mandatory image upload
        if (!this.hasImageUpload || !this.isImageUploadMandetory) {
          return;
        }

        // Check city availability first - don't update opacity if city is not available
        const cityStatus = this.getCityAvailabilityStatus();
        if (!cityStatus.isAvailable) {
          return;
        }

        // Check if images have been uploaded
        const imageUrls = this.getStringAttribute(this.productInfo, 'data-image-urls', '');
        const hasImages = imageUrls && imageUrls !== '""' && imageUrls !== '[]' && imageUrls !== '';

        // Get all submit buttons
        const submitButtons = this.querySelectorAll('[type="submit"], #AddonProductModalOpener');
        
        submitButtons.forEach(button => {
          // Only update opacity if button is not disabled for city unavailability
          const isDisabledForCity = button.classList.contains('button--disabled') && 
                                   button.querySelector('span')?.textContent.includes('Not Available in');
          
          if (!isDisabledForCity) {
            if (hasImages) {
              // Images uploaded - remove personalized gift class for full opacity
              button.classList.remove('button--personalized-gift');
            } else {
              // No images uploaded - add personalized gift class for reduced opacity
              if (!button.disabled && !button.hasAttribute('aria-disabled')) {
                button.classList.add('button--personalized-gift');
              }
            }
          }
        });
      }

      getFormData() {
        let data = {};
        let product = {};
        data.sections = this.cart.getSectionsToRender().map((section) => section.id);
        data.sections_url = window.location.pathname;
        product.id = this.form.querySelector('[name="id"]').value;
        // Get quantity from the quantity input if it exists, otherwise default to 1
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        product.quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        // Initialize properties object
        product.properties = {};

        // Add all properties
        product.properties['_parentProduct'] = `gid://shopify/Product/${this.dataset.productId}`;
        product.properties['_arabicCountrySelected'] = this.getStringAttribute(this, 'data-arabic-city', 'الرياض');
        product.properties['_city'] = this.convertToEnglishCity(this.getStringAttribute(this, 'data-city', 'Riyadh'));
        product.properties['_currencySelected'] = sessionStorage.currentCurrency || 'QAR';
        product.properties['_CuttOffTime'] = this.getStringAttribute(this, 'data-cut-off-time', '0');
        product.properties['_imagesUrl'] = this.isQuickViewModal ? JSON.stringify(this.isQuickViewModal.imageFormInput.getImageUrls()) : JSON.stringify(window.imageFromInput.getImageUrls());
        product.properties['_message'] = this.getStringAttribute(this, 'data-message', '""');
        product.properties['_product_description'] = this.getStringAttribute(this, 'data-product-description', 'null');
        product.properties['_product_handle'] = this.getStringAttribute(this, 'data-product-handle', 'null');
        product.properties['_product_image'] = this.getStringAttribute(this, 'data-product-image', 'null');
        product.properties['_product_type'] = this.getStringAttribute(this, 'data-product-type', 'null');

        data.items = [product];
        return data;
      }

      submitForm(data, evt) {
        let variantId = data.items[0].id;
        let config = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        };

        return fetch(window.Shopify.routes.root + 'cart/add.js', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.items) {
              // Cart items added successfully
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return response;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents({ ...response, id: `${variantId}` });
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // Check if we're in addon modal flow (on PDP when addon modal will open)
              // If so, just update cart icon without opening drawer
              const isAddonModalFlow = this.dataset.addonModalFlow === 'true';
              const hasAddonModal = document.getElementById('AddonProductModalOpener');
              const isPDP = window.location.pathname.includes('/products/');
              
              if (isAddonModalFlow || (hasAddonModal && isPDP && typeof ADDONS !== 'undefined' && Array.isArray(ADDONS) && ADDONS.length > 0)) {
                // On PDP with addons - update cart icon only, don't open drawer
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.updateCartIconOnly(response);
                });
              } else {
                // Normal flow - open cart drawer
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents({ ...response, id: `${variantId}` });
                });
              }
            }
          })
          .catch((e) => {
            console.error(e);
            throw e;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }


      validateImages() {
        if (this.imageLimit > 0 && this.isImageUploadMandetory) {
          return this.uploadedUrls.length > 0;
        }
        return true;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // For personalized gifts, only validate image upload if images are actually uploaded
        // This allows the button to show by default and only require validation when user tries to upload
        const imageUrls = this.getStringAttribute(this.productInfo, 'data-image-urls', '');
        const hasImageUploads = imageUrls && imageUrls !== '""' && imageUrls !== '[]' && imageUrls !== '';
        
        // Only validate image upload if user has actually attempted to upload images
        if (this.hasImageUpload && this.isImageUploadMandetory && hasImageUploads && !window.imageFromInput.validateImages()) {
          this.handleErrorMessage(this.imageUploadErrorMessage);
          return;
        }

        // Improved validation for product message
        const message = this.getStringAttribute(this, 'data-message', '');
        const hasRequiredMessage = !this.isProductMessageMandetory || message !== '""' && message !== '';
        
        if (this.hasProductMessage && this.isProductMessageMandetory && !hasRequiredMessage) {
          this.handleErrorMessage(this.productMessageErrorMessage);
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }

        let data = this.getFormData();
        this.submitForm(data, evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          this.errorMessage.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          });
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      handleAddons(addonsData, event, callback) {
        addonsData.items.forEach((item, index) => {
          addonsAddedToCart(item);
        });

        // Only add addons, not the main product (main product was already added when modal opened)
        // Ensure items are properly formatted for Shopify's cart/add.js endpoint
        const formattedItems = addonsData.items.map(item => {
          return {
            id: item.id || item.variant_id || item.variantId,
            quantity: item.quantity || 1,
            properties: item.properties || {}
          };
        }).filter(item => item.id); // Remove any items without valid IDs

        if (formattedItems.length === 0) {
          // No addons to add, just open cart drawer
          if (this.cart) {
            this.refreshAndOpenCartDrawer();
          }
          if (callback) callback({ items: [] });
          return Promise.resolve({ items: [] });
        }

        let addonsOnlyData = {
          items: formattedItems
        };
        
        // Submit addons only
        return this.submitFormAddonsOnly(addonsOnlyData, event).then((response) => {
          if (response && response.items) {
            // Cart items added successfully
          }
          // Open cart drawer after addons are added
          if (this.cart && response) {
            this.refreshAndOpenCartDrawer();
          }
          if (callback) callback(response);
          return response;
        });
      }

      // Submit form for addons only
      submitFormAddonsOnly(data, evt) {
        // Validate that we have items to add
        if (!data || !data.items || !Array.isArray(data.items) || data.items.length === 0) {
          return Promise.resolve({ items: [] });
        }

        // Prepare request data - Shopify's cart/add.js expects ONLY items array
        const requestData = {
          items: data.items.map(item => ({
            id: item.id || item.variant_id || item.variantId,
            quantity: parseInt(item.quantity) || 1,
            properties: item.properties || {}
          }))
        };
        
        let config = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestData),
        };

        // Add to cart
        return fetch(window.Shopify.routes.root + 'cart/add.js', config)
          .then((response) => response.json())
          .then((addResponse) => {
            if (addResponse.items) {
              // Cart items added successfully
            }
            if (addResponse.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: data.items[0]?.id || '',
                errors: addResponse.errors || addResponse.description,
                message: addResponse.message,
              });
              this.handleErrorMessage(addResponse.description);
              this.error = true;
              throw new Error(addResponse.description || 'Error adding addons to cart');
            }

            // Calculate item count
            const itemCount = addResponse.item_count || 
                             (addResponse.items && addResponse.items.reduce((sum, item) => sum + (item.quantity || 0), 0)) || 
                             0;

            const cartResponse = {
              ...addResponse,
              item_count: itemCount
            };

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: data.items[0]?.id || '',
                cartData: cartResponse,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            
            // Update cart icon/count
            this.updateCartIconOnly(cartResponse);
            
            return cartResponse;
          })
          .catch((e) => {
            console.error(e);
            this.error = true;
            throw e;
          })
          .finally(() => {
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      // Refresh cart drawer from server and open it
      refreshAndOpenCartDrawer() {
        if (!this.cart) return;
        
        const cartDrawer = document.querySelector('cart-drawer');
        const cartDrawerItems = document.querySelector('cart-drawer-items');
        const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : 
                       (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) ? window.Shopify.routes.cart_url :
                       `${window.Shopify.routes.root}cart`;
        
        // First refresh cart drawer items from server
        fetch(`${cartUrl}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            
            // Update cart drawer items with fresh data from server
            if (cartDrawerItems) {
              const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
              
              selectors.forEach(selector => {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  const clonedSource = sourceElement.cloneNode(true);
                  targetElement.replaceWith(clonedSource);
                }
              });
            }
            
            // Also fetch cart icon bubble section
            const sectionsToRender = this.cart.getSectionsToRender ? this.cart.getSectionsToRender() : [
              { id: 'cart-icon-bubble', section: 'cart-icon-bubble' }
            ];
            
            const iconSectionParams = sectionsToRender.map(s => `section_id=${s.section || s.id}`).join('&');
            
            return fetch(`${window.Shopify.routes.root}?${iconSectionParams}`)
              .then((iconResponse) => iconResponse.text())
              .then((iconHtml) => {
                const iconHtmlDoc = new DOMParser().parseFromString(iconHtml, 'text/html');
                const sectionsData = {};
                
                // Extract cart-drawer section from refreshed HTML
                const freshCartDrawer = html.querySelector('#cart-drawer') || html.querySelector('cart-drawer');
                if (freshCartDrawer) {
                  sectionsData['cart-drawer'] = freshCartDrawer.outerHTML;
                }
                
                // Extract cart-icon-bubble section
                sectionsToRender.forEach(({ id, section }) => {
                  const sectionId = section || id;
                  let sectionElement = iconHtmlDoc.getElementById(sectionId);
                  
                  if (!sectionElement) {
                    const shopifySections = iconHtmlDoc.querySelectorAll('.shopify-section');
                    for (const shopifySection of shopifySections) {
                      if (shopifySection.id === sectionId) {
                        sectionElement = shopifySection;
                        break;
                      }
                      const inner = shopifySection.querySelector(`#${sectionId}`);
                      if (inner) {
                        sectionElement = inner;
                        break;
                      }
                    }
                  }
                  
                  if (!sectionElement) {
                    sectionElement = iconHtmlDoc.querySelector(`[id="${sectionId}"]`);
                  }
                  
                  if (sectionElement) {
                    sectionsData[id] = sectionElement.outerHTML;
                  }
                });
                
                // Calculate item count
                let itemCount = 0;
                if (cartDrawerItems) {
                  const freshCartDrawerItems = document.querySelector('cart-drawer-items');
                  if (freshCartDrawerItems) {
                    const cartItems = freshCartDrawerItems.querySelectorAll('cart-item, .cart-item');
                    itemCount = cartItems.length;
                  }
                }
                
                if (!itemCount && sectionsData['cart-icon-bubble']) {
                  const iconBubbleDoc = new DOMParser().parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
                  const countBubble = iconBubbleDoc.querySelector('.cart-count-bubble span[aria-hidden="true"]') || 
                                     iconBubbleDoc.querySelector('.cart-count-bubble span');
                  if (countBubble) {
                    itemCount = parseInt(countBubble.textContent.trim()) || 0;
                  }
                }
                
                // Prepare parsed state
                const parsedState = {
                  sections: sectionsData,
                  item_count: itemCount
                };
                
                // Open cart drawer with fresh data
                if (cartDrawer && cartDrawer.renderContents) {
                  cartDrawer.renderContents(parsedState);
                } else if (cartDrawer && cartDrawer.open) {
                  cartDrawer.open();
                  
                  // Ensure currency conversion runs when drawer opens via open() method
                  setTimeout(() => {
                    // Hide any loading spinners
                    cartDrawer.querySelectorAll('.loading__spinner').forEach(spinner => {
                      spinner.classList.add('hidden');
                    });
                    
                    // Reinitialize currency conversion
                    if (typeof initialCurrencyChange === 'function') {
                      initialCurrencyChange();
                    }
                    
                    // Update footer count if function exists
                    if (typeof updateFooterCount === 'function') {
                      updateFooterCount();
                    }
                  }, 300);
                }
              });
          })
          .catch(error => {
            console.error('Error refreshing cart drawer:', error);
            // Fallback: just try to open drawer
            if (cartDrawer && cartDrawer.open) {
              cartDrawer.open();
            }
          });
      }

      // Update cart icon/count only without opening drawer
      updateCartIconOnly(response) {
        if (!this.cart) return;
        
        // Fetch complete cart data to ensure we have all required fields
        // The add response might not have all the fields the cart drawer needs
        fetch(`${routes.cart_url}.js`)
          .then(fetchResponse => fetchResponse.json())
          .then(cartData => {
            // Update window.latestCartData with complete cart data
            window.latestCartData = cartData;
            
            // Also update the cart drawer items data if it exists
            const cartDrawerItems = document.querySelector('cart-drawer-items');
            if (cartDrawerItems) {
              cartDrawerItems.latestCartData = cartData;
            }
            
            // Continue with UI updates
            this.updateCartUI(response, cartData);
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
            // Fallback: use the add response
            window.latestCartData = response;
            const cartDrawerItems = document.querySelector('cart-drawer-items');
            if (cartDrawerItems) {
              cartDrawerItems.latestCartData = response;
            }
            this.updateCartUI(response, response);
          });
      }
      
      // Helper method to update cart UI elements
      updateCartUI(response, cartData) {
        
        if (!this.cart) return;
        
        // Get item count from cart data
        const itemCount = cartData.item_count || (cartData.items && cartData.items.length) || 0;
        
        // Update cart icon bubble section
        const sectionsToRender = this.cart.getSectionsToRender();
        sectionsToRender.forEach((section) => {
          if (section.id === 'cart-icon-bubble') {
            const sectionId = section.section || section.id;
            const targetElement = document.getElementById('cart-icon-bubble');
            
            if (!targetElement) return;
            
            // Fetch fresh cart icon section
            fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`)
              .then(fetchResponse => fetchResponse.text())
              .then(text => {
                const html = new DOMParser().parseFromString(text, 'text/html');
                // Try to find the section content - it might be wrapped in .shopify-section
                let sectionContent = html.querySelector('.shopify-section');
                if (!sectionContent) {
                  sectionContent = html.querySelector(`#${sectionId}`);
                }
                if (!sectionContent) {
                  sectionContent = html.querySelector('#shopify-section-cart-icon-bubble');
                }
                if (!sectionContent) {
                  sectionContent = html.querySelector('#cart-icon-bubble');
                }
                if (!sectionContent) {
                  sectionContent = html.body.firstElementChild;
                }
                
                if (sectionContent && targetElement) {
                  // Update the entire cart-icon-bubble element with the new content
                  targetElement.innerHTML = sectionContent.innerHTML;
                  
                  // Re-attach event listeners
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer && cartDrawer.setHeaderCartIconAccessibility) {
                    cartDrawer.setHeaderCartIconAccessibility();
                  }
                }
              })
              .catch(error => {
                console.error('Error updating cart icon:', error);
              });
          }
          
          // Also silently refresh cart drawer content (without opening it) so it has latest data
          // This prevents loading issues when the drawer is opened later
          if (section.id === 'cart-drawer') {
            const cartDrawer = document.querySelector('cart-drawer');
            const cartDrawerItemsElement = document.querySelector('cart-drawer-items');
            
            if (cartDrawer && cartDrawerItemsElement) {
              // Fetch latest cart drawer data from server
              fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then(fetchResponse => fetchResponse.text())
                .then(text => {
                  const html = new DOMParser().parseFromString(text, 'text/html');
                  const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                  
                  selectors.forEach(selector => {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                    if (targetElement && sourceElement) {
                      // Preserve event listeners by updating innerHTML instead of replacing
                      if (selector === 'cart-drawer-items') {
                        // For cart-drawer-items, we need to preserve the element but update its content
                        // Store the latestCartData reference before updating
                        const currentLatestCartData = cartDrawerItemsElement.latestCartData || window.latestCartData;
                        targetElement.innerHTML = sourceElement.innerHTML;
                        // Restore the latestCartData after updating - use cartData passed to this method
                        if (cartDrawerItemsElement) {
                          cartDrawerItemsElement.latestCartData = currentLatestCartData || cartData;
                        }
                      } else {
                        // For footer, simple replace is fine
                        targetElement.innerHTML = sourceElement.innerHTML;
                      }
                    }
                  });
                  
                  // Ensure latestCartData is updated with complete cart data
                  window.latestCartData = cartData;
                  const updatedCartDrawerItems = document.querySelector('cart-drawer-items');
                  if (updatedCartDrawerItems) {
                    updatedCartDrawerItems.latestCartData = cartData;
                  }
                  
                  // Use setTimeout to ensure DOM updates are complete before reinitializing
                  setTimeout(() => {
                    // Hide all loading spinners in cart drawer
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                      cartDrawer.querySelectorAll('.loading__spinner').forEach(spinner => {
                        spinner.classList.add('hidden');
                      });
                      
                      // Also hide spinners in cart drawer items
                      cartDrawer.querySelectorAll('cart-drawer-items .loading__spinner').forEach(spinner => {
                        spinner.classList.add('hidden');
                      });
                    }
                    
                    // Also check for any cart item elements outside the drawer (for consistency)
                    document.querySelectorAll('#CartDrawer .loading__spinner').forEach(spinner => {
                      spinner.classList.add('hidden');
                    });
                    
                    // Reinitialize currency conversion for all price elements
                    // This is critical for prices to convert properly
                    if (typeof initialCurrencyChange === 'function') {
                      initialCurrencyChange();
                    }
                    
                    // Update footer count if function exists
                    if (typeof updateFooterCount === 'function') {
                      updateFooterCount();
                    }
                    
                    // Dispatch a custom event to notify that cart drawer was updated
                    const cartDrawerUpdateEvent = new CustomEvent('cart-drawer-updated', {
                      detail: { cartData: cartData }
                    });
                    document.dispatchEvent(cartDrawerUpdateEvent);
                  }, 100);
                })
                .catch(error => {
                  console.error('Error updating cart drawer content:', error);
                  // Fallback: ensure latestCartData is still set
                  window.latestCartData = cartData;
                  if (cartDrawerItemsElement) {
                    cartDrawerItemsElement.latestCartData = cartData;
                  }
                });
            }
          }
        });
      }

      // Helper methods to get typed attribute values with defaults
      getBooleanAttribute(element, attributeName, defaultValue) {
        if (!element) return defaultValue;
        const value = element.getAttribute(attributeName);
        return value === null ? defaultValue : value === 'true';
      }

      getNumberAttribute(element, attributeName, defaultValue) {
        if (!element) return defaultValue;
        const value = element.getAttribute(attributeName);
        return value === null ? defaultValue : parseInt(value, 10);
      }

      getStringAttribute(element, attributeName, defaultValue) {
        if (!element) return defaultValue;
        const value = element.getAttribute(attributeName);
        return value === null ? defaultValue : value;
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// Global function to update city in all product forms
window.updateProductFormCity = function() {
  const productForms = document.querySelectorAll('product-form');
  productForms.forEach(form => {
    if (form.forceCityUpdate) {
      form.forceCityUpdate();
    }
  });
};

// Global function to refresh city availability
window.refreshAllProductFormCities = function() {
  const productForms = document.querySelectorAll('product-form');
  productForms.forEach(form => {
    if (form.refreshCityAvailability) {
      form.refreshCityAvailability();
    }
  });
};

// Global function to force update city in all product forms
window.forceUpdateAllProductFormCities = function(city) {
  const productForms = document.querySelectorAll('product-form');
  productForms.forEach(form => {
    if (form.forceCityUpdate) {
      form.forceCityUpdate();
    }
  });
  
  // Also dispatch a custom event for any other components that might need it
  document.dispatchEvent(new CustomEvent('force-city-update', {
    detail: { city: city }
  }));
};

// Global function to update city in all product forms with a specific city value
window.updateAllProductFormCities = function(city) {
  const productForms = document.querySelectorAll('product-form');
  productForms.forEach(form => {
    if (form.updateCity) {
      form.updateCity(city);
    }
  });
  
  // Also dispatch a custom event for any other components that might need it
  document.dispatchEvent(new CustomEvent('city-updated', {
    detail: { city: city }
  }));
};

// Global function to test city availability for a specific city
window.testCityAvailability = function(city) {
  
  // Update localStorage
  localStorage.setItem('city_value', city);
  localStorage.setItem('city', city);
  
  // Update all product forms
  window.updateAllProductFormCities(city);
  
  // Log current status
  const productForms = document.querySelectorAll('product-form');
  productForms.forEach((form, index) => {
    const status = form.getCityAvailabilityStatus();
  });
};

// Test function for Arabic translation
window.testProductAvailabilityTranslation = function() {
  const isArabic = document.documentElement.lang === 'ar';
  
  // Test with different city names
  const testCities = ['Jubail', 'Al Khobar', 'Riyadh', 'Dammam'];
  
  testCities.forEach(testCity => {
    // Use global CityMatcher to get display name
    const displayCityName = window.CityMatcher ? 
      window.CityMatcher.getCityDisplayName(testCity, isArabic) : 
      testCity;
    const expectedEnglish = `Not Available in ${testCity}`;
    const expectedArabic = `غير متوفر في ${displayCityName}`;
    
    // Test the translation logic
    const translationText = isArabic ? 
      `غير متوفر في ${displayCityName}` : 
      `Not Available in ${displayCityName}`;
      
    // Translation test
  });
  
  return {
    isArabic,
    testCities: testCities
  };
};

// Test function for city matching
window.testCityMatching = function(selectedCity, availableCitiesList) {
  const productForm = document.querySelector('product-form');
  if (!productForm) {
    console.error('No product form found');
    return;
  }
  
  // Test normalization
  const normalizedSelected = productForm.normalizeCityName(selectedCity);
  const normalizedAvailable = availableCitiesList.split(',').map(city => productForm.normalizeCityName(city));
  
  
  // Test partial matching
  const partialMatch = normalizedAvailable.some(city => {
    const containsMatch = city.includes(normalizedSelected) || normalizedSelected.includes(city);
    const keyWords = normalizedSelected.split(' ').filter(word => word.length > 2);
    const cityKeyWords = city.split(' ').filter(word => word.length > 2);
    const keywordMatch = keyWords.some(keyword => 
      cityKeyWords.some(cityKeyword => 
        cityKeyword.includes(keyword) || keyword.includes(cityKeyword)
      )
    );
    return containsMatch || keywordMatch;
  });
  
  
  return {
    exactMatch: normalizedAvailable.includes(normalizedSelected),
    partialMatch,
    normalizedSelected,
    normalizedAvailable
  };
};
